<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { Globals } from "@/Globals";
import { goBack } from "@/NavigationHelper";
import { showSnackbar } from "@/UIHelper";

import {
  mountedBase,
  onSave,
  BaseSetup,
  dataLoaded,
  onDelete,
  loadImage,
} from "@/DataLoaderStatic";
import { getKennungValueDisplay } from "@/DataHelper";
import {
  begriffBezeichnung,
  globalsBezeichnung,
  globalsBegriffMemo,
} from "@/local";
const emit = defineEmits(["back"]);
const props = defineProps<{
  stammKen?: string;
  stammBez?: string;
  stammsatz?: number;
}>();
let selectedUser: any;
let user: ALLUser[] = [];
let bezeichnung: string = "";
let stammKennung: string = "";
let kennung: string = "";
let avatar = ref<string>("");
let text = ref<string>("Benutzer: ");
let showKopie = ref<boolean>(false);

let showSave = ref<boolean>(false);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  await reloadData();
  if (showKopie.value) {
    kennung = props.stammKen ?? "";
    bezeichnung = props.stammBez ?? "";
    text.value = "Vorlage wählen: ";
  }
  if ((selectedUser?.length === 0 || !selectedUser) && uiData.initialized) {
    selectedUser = user[0];
    // $forceUpdate();
  }
  if (!showKopie.value) {
    const avatarData = getKennungValueDisplay(user, "Bild", uiData.columns);
    if (avatarData) {
      if (avatarData.data) {
        avatar.value = avatarData.data;
      } else {
        await loadImage(uiData, pageParams, avatarData);
        avatar.value = uiData.avatarIcon ?? "";
      }
    }
  }
  uiData.initialized = true;
});

async function reloadData() {
  if (props.stammsatz) {
    const userData = await AUApi.Current.getUser(props.stammsatz, 0);
    const allUser = userData.data.data;
    user = allUser.filter((e: any) => e.test !== true);
    if (user.length > 0) {
      dataLoaded(uiData, pageParams, userData);
    } else {
      const userVorlage = await AUApi.Current.getUser(0, 1);
      user = userVorlage.data.data;
      if (userVorlage.data.data) {
        showKopie.value = true;
        dataLoaded(uiData, pageParams, userVorlage);
      }
    }
  }
}
async function deleteUser() {
  try {
    AUApi.Current.deleteUser(selectedUser.aic).then((res: any) => {
      const meldung = res.data.info;
      if (meldung) {
        showSnackbar({
          text: meldung,
          color: "info",
        });
      }
    });
    const userData = await AUApi.Current.getUser(0, 0);
    if (userData) {
      const allUser = userData.data.data;
      uiData.data = allUser.filter((e: any) => e.test !== true);
    }

    initUser(false);
  } catch {
    // Meldung
  }
}
function initUser(kopie: boolean) {
  if (!kopie) {
    selectedUser = [];
  }
}
async function neuAnlageUser(kopie: boolean, change?: boolean) {
  let aic = 0;
  let copyAic = 0;
  if (kopie) {
    copyAic = selectedUser.aic;
  } else {
    aic = selectedUser.aic;
  }
  if (change) {
    kennung = selectedUser.kennung;
  }
  AUApi.Current.newUser(
    aic,
    kennung,
    bezeichnung,
    2,
    "",
    "",
    uiData.data.sprache.aic,
    uiData.data.land.aic,
    props.stammsatz ?? 0,
    0,
    copyAic
  ).then((res: any) => {
    const changed = res.data.aic;
    const fehler = res.data.info;
    if (fehler) {
      showSnackbar({
        text: fehler,
        color: "error",
      });
    } else if (changed) {
      showSnackbar({
        text: globalsBegriffMemo(
          Globals.Begriff,
          "Benutzer_anlegen",
          "Benutzer wurde erfolgreich angelegt/geändert!"
        ),
        color: "info",
      });
      showKopie.value = false;
      text.value = "Benutzer";
      uiData.initialized = false;
      selectedUser = [];
      showSave.value = false;
      reloadData();
    }
  });
}

function selectedUserChanged(args: ALLUser) {
  uiData.initialized = false;
  const userLocal: any = user.find((m: any) => m.bezeichnung === args);
  selectedUser = userLocal;
  uiData.data = userLocal;
  if (showKopie) {
    kennung = stammKennung ?? "";
    bezeichnung = props.stammBez ?? "";
  }
  setTimeout(() => reloadData(), 100);
}
function filterFunction(
  item: any,
  queryText: string,
  itemText: string
): boolean {
  queryText = queryText.toLowerCase();
  if (item.headerHtml) {
    return true;
  }
  if (
    (
      itemText &&
      itemText.toLowerCase &&
      itemText.toLowerCase() + ""
    ).startsWith(queryText)
  ) {
    return true;
  }
  if (item.rowData) {
    const x = item.rowData.find(
      (t: string) =>
        t && t.toLowerCase && (t.toLowerCase() + "").startsWith(queryText)
    );
    if (x) {
      return true;
    }
  }
  return false;
}
function resetPassword() {
  AUApi.Current.resetPassword(selectedUser.kennung).then((res: any) => {
    const fehler = res.data.info;
    if (fehler) {
      showSnackbar({
        text: fehler,
        color: "error",
      });
    } else {
      showSnackbar({
        text: globalsBegriffMemo(
          Globals.Begriff,
          "Web_PW_zurueckgesetzt",
          "Passwort wurde erfolgreich zurückgesetzt!"
        ),
        color: "info",
      });
    }
  });
}
</script>
<template>
  <v-sheet :loading="uiData.showLoading" v-if="uiData.initialized">
    <v-toolbar color="dvhBackground" class="white--text">
      {{ text }}
      <v-avatar v-if="avatar && !showKopie" size="38">
        <v-img :src="avatar"
      /></v-avatar>

      <v-toolbar-items>
        <v-combobox
          ref="comboList"
          v-if="user && user.length > 0"
          style="width: 400px"
          density="comfortable"
          variant="outlined"
          class="pa-2"
          :items="user"
          :label="globalsBezeichnung(Globals.Begriff, 'User', 'User auswählen')"
          :placeholder="globalsBezeichnung(Globals.Begriff, 'User', 'User')"
          item-title="bezeichnung"
          item-value="id"
          v-model="selectedUser"
          @update:modelValue="selectedUserChanged"
          :filter="filterFunction"
        >
        </v-combobox>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <!-- <v-btn v-if="showKopie" variant="text" color="white" @click="initUser(true)">
        <v-icon>content_copy</v-icon>
        kopie
      </v-btn> -->
      <v-btn dark icon="mdi-close" @click="goBack()"> </v-btn>
    </v-toolbar>

    <v-card refs="benutzer">
      <v-card-text class="pa-2">
        <v-row v-if="showKopie">
          <v-col cols="12" sm="6" class="pa-2">
            <v-text-field
              required
              :label="
                globalsBezeichnung(
                  Globals.Begriff,
                  'Bezeichnung',
                  'Bezeichnung'
                )
              "
              v-model="bezeichnung"
            />
          </v-col>
          <v-col cols="12" sm="6" class="pa-2">
            <v-text-field
              required
              :label="globalsBezeichnung(Globals.Begriff, 'Kennung', 'Kennung')"
              v-model="kennung"
            />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" sm="6" class="pa-2">
            <EditTextField v-model="bezeichnung" kennung="Bezeichnung" />
          </v-col>
          <v-col cols="12" sm="6" class="pa-2">
            <EditTextField v-model="kennung" kennung="Kennung" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" class="pa-2">
            <EditComboBox
              id="Sprache"
              name="Sprache"
              kennung="Sprache"
              @change="showSave = true"
            /> </v-col
          ><v-col cols="12" sm="6" class="pa-2">
            <EditComboBox
              id="Land"
              name="Land"
              kennung="Land"
              @change="showSave = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" class="pa-2">
            <EditTextField kennung="Tel" />
          </v-col>
          <v-col cols="12" sm="6" class="pa-2">
            <EditTextField kennung="E-Mail" />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" sm="6" class="pa-2">
            <EditComboBox :isRequired="true" kennung="Person" />
          </v-col>
          <v-col cols="12" sm="6" class="pa-2">
            <EditComboBox kennung="Benutzergruppe" />
          </v-col>
        </v-row> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="showKopie"
          variant="text"
          color="green"
          @click="neuAnlageUser(true)"
          prepend-icon="mdi-content-copy"
          :text="begriffBezeichnung('Kopieren')"
        >
        </v-btn>
        <v-btn
          variant="text"
          color="green"
          @click="resetPassword()"
          prepend-icon="mdi-lock-reset"
          :text="begriffBezeichnung('InitPW')"
        >
        </v-btn>
        <v-btn
          :disabled="!showSave"
          variant="text"
          color="red"
          @click="neuAnlageUser(false, true)"
          prepend-icon="mdi-content-save"
          :text="begriffBezeichnung('Speichern')"
        >
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<style scoped></style>
